/* ORITUELS · scripts du thème "ORITUELS 50+ · CRO" */
(function () {
  'use strict';
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  /* ---- Apparition au scroll ---- */
  function reveal(root) {
    var els = $$('.ori-reveal:not(.is-in), .ori-panel:not(.is-in)', root);
    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -10% 0px', threshold: .1 });
    els.forEach(function (e, i) { if (e.classList.contains('ori-reveal')) e.style.transitionDelay = (i % 4) * 80 + 'ms'; io.observe(e); });
  }

  /* ---- Header : ombre au scroll + menu mobile ---- */
  function header() {
    var hd = document.querySelector('[data-ori-hd]'); if (!hd || hd.__o) return; hd.__o = 1;
    var on = function () { hd.classList.toggle('is-scrolled', window.scrollY > 8); }; on();
    window.addEventListener('scroll', on, { passive: true });
    var dr = document.querySelector('[data-ori-drawer]'); if (!dr) return;
    var open = function (v) { dr.classList.toggle('is-open', v); document.documentElement.style.overflow = v ? 'hidden' : ''; };
    $$('[data-ori-open]').forEach(function (b) { b.addEventListener('click', function () { open(true); }); });
    $$('[data-ori-close]', dr).forEach(function (b) { b.addEventListener('click', function () { open(false); }); });
    $$('a', dr).forEach(function (a) { a.addEventListener('click', function () { open(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
  }

  /* ---- Comparateur avant / après ---- */
  function compare(root) {
    $$('[data-ori-cmp]', root).forEach(function (c) {
      if (c.__o) return; c.__o = 1;
      var set = function (x) { var r = c.getBoundingClientRect(), p = Math.max(4, Math.min(96, (x - r.left) / r.width * 100)); c.style.setProperty('--p', p + '%'); };
      var drag = false;
      c.addEventListener('pointerdown', function (e) { drag = true; set(e.clientX); });
      window.addEventListener('pointermove', function (e) { if (drag) set(e.clientX); });
      window.addEventListener('pointerup', function () { drag = false; });
      c.addEventListener('touchmove', function (e) { if (e.touches[0]) set(e.touches[0].clientX); }, { passive: true });
      /* petite démonstration à l'arrivée */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          if (!es[0].isIntersecting) return; io.disconnect();
          var t0 = performance.now();
          (function an(t) { var k = Math.min(1, (t - t0) / 1400), p = 50 + Math.sin(k * Math.PI * 2) * 18 * (1 - k); c.style.setProperty('--p', p + '%'); if (k < 1 && !drag) requestAnimationFrame(an); })(t0);
        }, { threshold: .6 });
        io.observe(c);
      }
    });
  }

  /* ---- Vidéos : lecture à l'écran, son au toucher ---- */
  function videos(root) {
    $$('[data-ori-vids]', root).forEach(function (wrap) {
      if (wrap.__o) return; wrap.__o = 1;
      var vids = $$('video', wrap);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) e.target.play().catch(function () {}); else e.target.pause(); }); }, { threshold: .55 });
        vids.forEach(function (v) { io.observe(v); });
      }
      $$('.ori-vid', wrap).forEach(function (card) {
        var v = card.querySelector('video'), b = card.querySelector('.ori-vid__snd'); if (!v || !b) return;
        card.addEventListener('click', function () {
          var on = v.muted;
          vids.forEach(function (o) { o.muted = true; }); $$('.ori-vid__snd', wrap).forEach(function (x) { x.classList.remove('is-on'); });
          v.muted = !on; if (on) { b.classList.add('is-on'); v.play().catch(function () {}); }
        });
      });
    });
  }

  /* ---- Avis : afficher plus ---- */
  function reviews(root) {
    $$('[data-ori-more]', root).forEach(function (b) {
      if (b.__o) return; b.__o = 1;
      b.addEventListener('click', function () { var g = document.getElementById(b.getAttribute('data-ori-more')); if (g) g.classList.remove('is-collapsed'); });
    });
  }

  /* ---- Lien rapide vers le test de l'eau ---- */
  function waterCta(root) {
    $$('[data-ori-wcta]', root).forEach(function (f) {
      if (f.__o) return; f.__o = 1;
      f.addEventListener('submit', function (e) { e.preventDefault(); var v = f.querySelector('input').value.trim(); location.href = f.getAttribute('action') + (v ? '?ciudad=' + encodeURIComponent(v) : ''); });
    });
  }

  /* ---- Pack rituel : les 3 articles restent ensemble dans le panier ---- */
  var TAG = 'ori-rituel', SIZE = 3, busy = false, timer = null;
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function change(key, qty) { return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }); }
  function seq(list, fn) { return list.reduce(function (p, x) { return p.then(function () { return fn(x); }); }, Promise.resolve()); }
  function lines(cart) { return (cart.items || []).filter(function (i) { return i.properties && i.properties._bundle === TAG; }); }
  function refresh() { ['cart:refresh', 'cart:updated', 'cart-updated'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: {} })); }); }
  window.__oriClearBundle = function () {
    return getCart().then(function (cart) { var l = lines(cart); if (l.length) { busy = true; return seq(l, function (x) { return change(x.key, 0); }).then(function () { busy = false; }); } }).catch(function () { busy = false; });
  };
  function audit() {
    if (busy) return;
    getCart().then(function (cart) {
      var l = lines(cart); if (!l.length) return;
      if (l.length < SIZE) { busy = true; seq(l, function (x) { return change(x.key, 0); }).then(function () { busy = false; refresh(); }).catch(function () { busy = false; }); return; }
      var over = l.filter(function (x) { return x.quantity > 1; });
      if (over.length) { busy = true; seq(over, function (x) { return change(x.key, 1); }).then(function () { busy = false; refresh(); }).catch(function () { busy = false; }); }
    }).catch(function () {});
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(audit, 350); }
  if (!window.__oriGuard) {
    window.__oriGuard = true;
    var RE = /\/cart\/(add|change|update|clear)(\.js)?/, _f = window.fetch;
    window.fetch = function () { var u = arguments[0]; if (u && u.url) u = u.url; var hit = typeof u === 'string' && RE.test(u); return _f.apply(this, arguments).then(function (res) { if (hit) schedule(); return res; }); };
    var _o = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) { if (typeof u === 'string' && RE.test(u)) this.addEventListener('load', schedule); return _o.apply(this, arguments); };
    ['cart:updated', 'cart-updated', 'cart:refresh'].forEach(function (n) { document.addEventListener(n, schedule); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
    schedule();
  }

  /* ---- Bloc d'achat ---- */
  function buy(root) {
    $$('[data-ori-buy]', root).forEach(function (r) {
      if (r.__o) return; r.__o = 1;
      var D = r.dataset, data = {};
      try { data = JSON.parse(r.querySelector('[data-ori-buy-json]').textContent); } catch (e) { return; }
      var sel = { main: 0, gift: 0 };
      var main = r.querySelector('[data-ori-gal-main]'), thumbs = $$('[data-ori-thumb]', r), cur = 0;
      function show(i) { if (!thumbs.length) return; cur = (i + thumbs.length) % thumbs.length; main.src = thumbs[cur].getAttribute('data-src'); thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === cur); }); }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var pv = r.querySelector('[data-ori-prev]'), nx = r.querySelector('[data-ori-next]');
      if (pv) pv.addEventListener('click', function () { show(cur - 1); });
      if (nx) nx.addEventListener('click', function () { show(cur + 1); });

      function bind(name, cb) {
        var ins = $$('input[name="' + name + '"]', r);
        var s = function () { ins.forEach(function (i) { i.closest('label').classList.toggle('is-on', i.checked); if (i.checked) cb(+i.value); }); };
        ins.forEach(function (i) { i.addEventListener('change', s); }); s();
      }
      bind('ori-main-' + D.sid, function (i) { sel.main = i; var k = data.kit[i]; if (k && k.img && main) { main.src = k.img; thumbs.forEach(function (t) { t.classList.remove('is-on'); }); } $$('[data-ori-kitname]', r).forEach(function (e) { e.textContent = k ? k.title : ''; }); });
      bind('ori-gift-' + D.sid, function (i) { sel.gift = i; var g = data.gift[i]; $$('[data-ori-giftimg]', r).forEach(function (e) { if (g && g.img) e.src = g.img; }); });

      /* minuteur des cadeaux */
      var mn = parseInt(D.min, 10) || 30, t = r.querySelector('[data-ori-timer]'), KEY = 'ori_deadline_v3', end;
      try { var sv = parseInt(localStorage.getItem(KEY), 10); end = sv && sv > Date.now() && sv < Date.now() + mn * 6e4 ? sv : Date.now() + mn * 6e4; localStorage.setItem(KEY, String(end)); } catch (e) { end = Date.now() + mn * 6e4; }
      (function tk() { if (!t) return; var d = end - Date.now(); if (d <= 0) { t.parentNode.removeChild(t); return; } var a = Math.floor(d / 6e4), b = Math.floor(d % 6e4 / 1e3); t.textContent = a + ':' + (b < 10 ? '0' : '') + b; setTimeout(tk, 1000); })();

      /* fenêtre des parfums */
      var m = r.querySelector('[data-ori-modal]');
      var op = function () { m.hidden = false; }, cl = function () { m.hidden = true; };
      $$('[data-ori-help]', r).forEach(function (b) { b.addEventListener('click', op); });
      $$('[data-ori-mclose]', r).forEach(function (b) { b.addEventListener('click', cl); });
      if (m) m.addEventListener('click', function (e) { if (e.target === m) cl(); });

      /* ajout au panier + direction paiement */
      var cta = r.querySelector('[data-ori-cta]'), err = r.querySelector('[data-ori-err]'), label = cta.textContent;
      cta.addEventListener('click', function () {
        err.hidden = true; cta.disabled = true; cta.textContent = D.adding;
        var items = [{ id: data.kit[sel.main].id, quantity: 1, properties: { _bundle: TAG } }];
        if (data.gift.length) items.push({ id: data.gift[sel.gift].id, quantity: 1, properties: { _bundle: TAG } });
        if (data.ebook) items.push({ id: data.ebook, quantity: 1, properties: { _bundle: TAG } });
        window.__oriClearBundle().then(function () {
          return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
        }).then(function (res) { return res.json().then(function (d) { if (!res.ok) throw new Error(d.description || d.message); return d; }); })
          .then(function () { window.location.href = D.after === 'cart' ? '/cart' : '/checkout'; })
          .catch(function () { err.textContent = D.err; err.hidden = false; cta.disabled = false; cta.textContent = label; });
      });

      /* barre d'achat fixe sur mobile */
      var st = document.querySelector('[data-ori-sticky="' + D.sid + '"]');
      if (st && 'IntersectionObserver' in window) {
        st.querySelector('button').addEventListener('click', function () { r.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        new IntersectionObserver(function (e) { st.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(cta);
      }
    });
  }

  function boot(root) { reveal(root); compare(root); videos(root); reviews(root); waterCta(root); buy(root); }
  header();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
  document.addEventListener('shopify:section:load', function (e) { header(); boot(e.target); });
})();
